/**
 * Check whether the user's device has hover support.
 * @returns {boolean} Whether the device has hover support
 */
export default function deviceHasHover() {
	const check = window.matchMedia('(any-hover: hover)')
	// Logger.debug('Does device have hover?', check)
	return check.matches
}
